<template>
    <a-config-provider :locale="zhCN">
      <router-view/>
    </a-config-provider>
</template>

<script setup>
import {onMounted} from 'vue';
import Aegis from 'aegis-web-sdk';

import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';

dayjs.locale('zh-cn');

onMounted(() => {
  // 腾讯云可观测云平台前端性能监控组件
  new Aegis({
    id: 'LlovlSjL9zmnm5ljPb', // 上报 id
    spa: true,
    reportApiSpeed: true,
    api: {
      apiDetail: true, // 上报接口请求参数和返回值
      reportRequest: true, // 全量接口上报
      reqHeaders: ['Authentication-Info'] // 记录 request header
    },
  });
});
</script>

<style>
html, body, #app {
  height: 100%;
  padding: 0;
  margin: 0;

  --vxe-ui-table-header-font-color: rgba(48, 48, 48, 0.88);
  --vxe-ui-table-header-background-color: #FAFAFA;
  
  --vxe-ui-font-color: rgba(48, 48, 48, 0.88);

  --vxe-ui-table-border-color: #EBEBEB;
}

.ant-modal-root div[aria-hidden="true"] {
  display: none !important;
}

/* 全局 a-card 样式：统一为圆角白卡片 + 灰色渐变标题栏 + 蓝色竖条标题 */
.ant-card {
  border-radius: 10px;
  overflow: hidden;
}

.ant-card.ant-card-bordered {
  border: 1px solid #e8ecef;
}

.ant-card .ant-card-head {
  padding: 0 20px;
  background: linear-gradient(180deg, #fafafa, #f5f5f5);
  border-bottom: 1px solid #eef1f5;
}

.ant-card .ant-card-head-title {
  position: relative;
  padding: 14px 0 14px 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.88);
}

/* 标题左侧蓝色竖条 */
.ant-card .ant-card-head-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  border-radius: 2px;
  background: linear-gradient(180deg, #4096ff, #1677ff);
}

.ant-card .ant-card-extra {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
}

.ant-card .ant-card-body {
  padding: 20px;
}

</style>
